
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { forgotPassword } from "../../actions/authAction";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { Button, Form, Grid, Header, Segment } from 'semantic-ui-react'

class ForgotPassword extends Component {

    constructor() {
        super();
        this.state = {
            userEmail: '',
            errors: {}
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            console.log("===============Errors bad data==================" + JSON.stringify(nextProps.errors))
            this.setState({ errors: nextProps.errors });
        }
    }

    onChange = e =>
        this.setState({
            [e.target.name]: e.target.value
        });

    onSubmit = e => {
        e.preventDefault();

        if (this.state.userEmail && this.validateEmail(this.state.userEmail)) {
            this.setState({ errors: "Please enter valid Email" });
            const userData = {
                userEmail: this.state.userEmail,
            };
            try {
                this.props.forgotPassword(userData)
            } catch (error) {
                this.state.errors(error)
            }
        } else {
            this.setState({ errors: "Please enter valid Email" });
        }


    };

    validateEmail = email => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    render() {
        const invalid = Object.keys(this.state.errors).length > 0 && true;
        let credence_error = <div style={{ marginBottom: "5px", color: "red" }}>{this.state.errors}</div>

        return (
            <div>
                <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
                    <Grid.Column style={{ maxWidth: 450 }}>
                        <Form size='large'>
                            <Segment.Group>
                                <Segment><Header as='h2' color='teal' textAlign='center'>
                                    <span>TeleRx</span>
                                </Header></Segment>
                                <Segment >
                                    {invalid ? credence_error : <span></span>}
                                    <Form.Input fluid icon='envelope' iconPosition='left' placeholder='Email Address'
                                        invalid={invalid}
                                        type="email"
                                        name="userEmail"
                                        value={this.state.userEmail}
                                        error={invalid}
                                        onChange={this.onChange}
                                        required />
                                    <Button color='teal' fluid size='large' onClick={this.onSubmit}>
                                        Reset Password
                                    </Button></Segment>
                            </Segment.Group>

                        </Form>
                        {/* <Message>
                        New to us? <a href='#'>Sign Up</a>
                    </Message> */}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

ForgotPassword.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired
    }).isRequired,
    forgotPassword: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(mapStateToProps, { forgotPassword })(withRouter(ForgotPassword));